module.exports = __webpack_public_path__ + "img/webinar-conqueror.1a25e647.png";